import { useQuery } from '@tanstack/react-query'
import { supabaseApi } from '~/supabase/api'

export const useGetModels = () => {
  return useQuery({
    queryKey: ['get-product-codes'],
    queryFn: async () => {
      const { data, error } = await supabaseApi
        .from('models_v2')
        .select('*, suppliers (*)')
        .neq('status', 'deprecated')
      if (!data && error) throw error

      return data
    },
  })
}
